import { getCenter } from "geolib";
import context from "lib/stores/context";
import { WebMercatorViewport } from "@deck.gl/core";
import { getBoundingBox } from "lib/map/functions";

export default function onChangeActiveCountry(
  activeCountry,
  selectedProduct,
  prevActiveCountry,
  countries,
  mapData,
  linear,
  transitionDuration,
) {
  if (activeCountry && selectedProduct) {
    if (prevActiveCountry !== activeCountry) {
      // mapData.selectedProduct = null;
      mapData.activeCountry = activeCountry;
    }
    return;
  }
  if (!activeCountry) return;

  // prevActiveCountry = activeCountry;

  const country = countries[activeCountry];
  // const formattedCountryCoords = countryCoords.map(coord => ({
  //   to: { coordinates: coord }
  // }));

  const bounds = {
    minLat: country.bounds.boundsTwo[1],
    minLng: country.bounds.boundsTwo[0],
    maxLat: country.bounds.boundsOne[1],
    maxLng: country.bounds.boundsOne[0],
  };

  const mViewport = new WebMercatorViewport({
    width: window.innerWidth,
    height: window.innerHeight,
    longitude: country.centroid.cx,
    latitude: country.centroid.cy,
    zoom: 0,
  });

  const { longitude, latitude, zoom } = mViewport.fitBounds(
    [
      [bounds.minLng, bounds.minLat],
      [bounds.maxLng, bounds.maxLat],
    ],
    {
      padding: getPadding(),
    },
  );

  let zoomForScreenSize;

  if (window.innerWidth > 1600) {
    zoomForScreenSize = zoom * 0.7;
  } else if (window.innerWidth <= 1600 && window.innerWidth > 768) {
    zoomForScreenSize = zoom * 0.7;
  } else if (window.innerWidth < 768) {
    zoomForScreenSize = zoom * 0.5;
  } else {
    zoomForScreenSize = zoom * 0.9;
  }

  mapData.viewState = {
    ...mapData.viewState,
    transitionDuration,
    transitionInterpolator: linear,
    longitude: country.centroid.cx,
    latitude: country.centroid.cy,
    target: [0, 0, 0],
    pitch: 0,
    zoom: zoomForScreenSize,
  };
}

function getPadding() {
  if (window.innerWidth > 1600) {
    return 250;
  } else if (window.innerWidth <= 1600 && window.innerWidth > 768) {
    return 150;
  } else {
    return 0;
  }
}
